import { useQuery } from '@apollo/client';

import { TeamMembersDocument, TeamMembersQuery } from './teamMembers.gql';

export type TeamMember =
  TeamMembersQuery['viewer']['company']['teamMembers']['edges'][number]['node'];

export const useTeamMembers = (companyProfileId = '') => {
  const { data, ...hook } = useQuery(TeamMembersDocument, {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: !companyProfileId,
    variables: { companyProfileId },
  });

  const teamMembers =
    data?.viewer.company.teamMembers.edges.map((edge) => edge.node) || [];

  return { ...hook, teamMembers };
};

export type TeamMembers = NonNullable<
  ReturnType<typeof useTeamMembers>['teamMembers']
>;

export function refetchTeamMembersQuery(companyProfileId: string) {
  return {
    query: TeamMembersDocument,
    variables: { companyProfileId },
  };
}
